module.exports = __webpack_public_path__ + "img/maestro.45847f92.png";